import { Box, MenuItem, Select } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

export const SelectReviewerDropdown = ({
  value,
  options,
  onChange,
}: {
  value: any;
  options: { value: any; label: string }[];
  onChange: (newValue: any) => void;
}) => {
  const { palette } = useTheme();
  const isValidValue = options.some((opt) => opt.value === value);
  const displayedValue = isValidValue ? value : '';

  return (
    <Box>
      <Select
        value={displayedValue}
        onChange={(e) => onChange(e.target.value)}
        displayEmpty
        fullWidth
        renderValue={(selected) => {
          if (!isValidValue || selected === '') return 'Please choose';
          const match = options.find((opt) => opt.value === selected);
          return match?.label || selected;
        }}
      >
        <MenuItem value="" disabled>
          Please choose
        </MenuItem>

        {options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};
